module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<form id=\"brand-form\"> <div class=\"row\"> <div class=\"col-sm-6 section-margin-bottom-sm\"> <h4> Brand Name <small class=\"glyphicon glyphicon-question-sign text-muted hidden-xs\" data-toggle=\"tooltip\" title=\"Used in page's <title> tag.\" data-placement=\"top\"></small> </h4> <input id=\"name\" type=\"text\" class=\"form-control\" value=\"")
    ; __append(escapeFn( locals.brandName ))
    ; __append("\" placeholder=\"Example Company\"> </div> <div class=\"col-sm-6 section-margin-bottom-sm\"> <div id=\"color_picker\"></div> </div> </div> <div class=\"row\"> <div class=\"col-sm-6 section-margin-bottom-sm\"> <h4> Logo Image <button class=\"btn btn-red btn-xs pull-right remove-image\" data-remove-field=\"logo\">Reset Logo</button> </h4> <div id=\"logo_image_upload\"></div> </div> <div class=\"col-sm-6 section-margin-bottom-sm\"> <h4> Logo URL <small class=\"glyphicon glyphicon-question-sign text-muted hidden-xs\" data-toggle=\"tooltip\" title=\"Link used when the Logo Image is clicked.\" data-placement=\"top\"></small> </h4> <input id=\"logo_href\" type=\"text\" class=\"form-control\" value=\"")
    ; __append(escapeFn( locals.logoHref ))
    ; __append("\" placeholder=\"https://example.com\"> </div> </div> <div class=\"row\"> <div class=\"col-sm-6 section-margin-bottom-sm\"> <h4> Ad Image <small>min. width: ")
    ; __append(escapeFn( locals.adImgMinWidth ))
    ; __append("px</small> <button class=\"btn btn-red btn-xs pull-right remove-image\" data-remove-field=\"ad\">Reset Ad</button> </h4> <div id=\"ad_image_upload\"></div> </div> <div class=\"col-sm-6 section-margin-bottom-sm\"> <h4> Ad URL <small class=\"glyphicon glyphicon-question-sign text-muted hidden-xs\" data-toggle=\"tooltip\" title=\"Link used when the Ad Image is clicked.\" data-placement=\"top\"></small> </h4> <input id=\"ad_href\" type=\"text\" class=\"form-control\" value=\"")
    ; __append(escapeFn( locals.adHref ))
    ; __append("\" placeholder=\"https://example.com/ad1\"> </div> </div> <div class=\"row\"> <div class=\"col-sm-6\"> <button id=\"preview-tracking-page\" type=\"button\" class=\"btn btn-default btn-block\">Preview Tracking Page <small class=\"text-muted\">(Recommended)</small></button> <button type=\"submit\" class=\"btn btn-blue btn-block\">Save Brand</button> </div> </div> </form> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./templates/brand_page.ejs
// module id = 829
// module chunks = 1